import { Component, uiElement, uiEvent } from "@kluntje/core";
import { addClass, removeClass, find, waitFor } from "@kluntje/js-utils/lib/dom-helpers";
import { ACTIVE } from "Constants/cssClasses";
import { CookieSettingsOverlay } from "Components/wec-m-cookie-settings-overlay/wec-m-cookie-settings-overlay";
import CookieService from "Services/CookieService";
import FocusService from "Services/FocusService";
import ScrollLockService from "Services/ScrollLockService";
import EditModeService from "Services/EditModeService";

export class CookieOverlay extends Component {
  @uiElement(".wec-m-cookie-overlay__btn--more-info")
  moreInfoBtn: HTMLButtonElement;

  @uiElement(".wec-m-cookie-overlay__btn--accept-all")
  acceptAllBtn: HTMLButtonElement;

  settingsOverlay?: CookieSettingsOverlay;

  get shouldOpen() {
    return CookieService.cookiesAllowed === false && EditModeService.editModeActive === false;
  }

  afterComponentRender() {
    if (this.shouldOpen) this.open();
    const settingsOverlay = find<CookieSettingsOverlay>(document.body, "#cookie-settings-overlay");
    if (settingsOverlay !== null) this.settingsOverlay = settingsOverlay;
  }

  open() {
    addClass(this, ACTIVE);
    FocusService.trapFocusIn(this);
    ScrollLockService.lockPage();
  }

  close() {
    removeClass(this, ACTIVE);
    FocusService.unTrapFocusIn(this);
    ScrollLockService.unlockPage();
  }

  @uiEvent("moreInfoBtn", "click")
  async handleMoreInfoBtnClick() {
    this.close();
    if (this.settingsOverlay === undefined) return;
    await waitFor(300);
    this.settingsOverlay.open();
  }

  @uiEvent("acceptAllBtn", "click")
  handleAcceptAllBtnClick() {
    this.close();
    if (this.settingsOverlay === undefined) return;
    CookieService.allowCookies();
    this.settingsOverlay.acceptAllCategories();
  }
}

customElements.define("wec-m-cookie-overlay", CookieOverlay);
